(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["request-more-info-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('boardco-request-info-modal')) {
    class BoardcoRequestInfoModal extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;
        this._connected = true;
        this._controller = new AbortController();
        this._dialog = this.querySelector('#request-info-modal-dialog');
        this._trigger = this.querySelector('#request-more-info-button-1');
        this._title = this.querySelector('#request-info-modal-title');
        this._frame = this.querySelector('[data-request-info-frame]');
        this._live = this.querySelector('[data-request-info-live]');
        this._loadingStatus = this.querySelector('[data-request-info-loading]');
        this._stateError = this.querySelector('[data-request-info-state-error]');
        this._external = this.querySelector('[data-request-info-external]');
        this._fallback = this.querySelector('[data-request-info-fallback]');
        this._retry = this.querySelector('[data-request-info-retry]');
        this._views = this.querySelectorAll('[data-request-info-view]');
        this._stateOptions = this.querySelectorAll('[data-request-info-state-option]');
        this._attempt = 0;
        this._state = 'closed';
        this._historyOwned = false;
        this._historyToken = '';
        this._selectedState = '';
        this._formId = '';
        this._contextUrl = '';
        this._productUrl = '';
        this._iframe = null;
        this._loadTimer = null;
        this._loadStartedAt = 0;
        this._backdropPointerDown = false;
        this._scrollLock = null;

        if (!window.__boardcoPageViewSent) {
          window.__boardcoPageViewSent = true;
          this.publish('boardco:boat_page_view', {});
        }

        if (!this._dialog || !this._trigger || !this._frame || !this._title) return;

        const listenerOptions = { signal: this._controller.signal };

        this._trigger.addEventListener('click', (event) => {
          this.publish('boardco:button_click', {
            button: this.dataset.requestInfoButtonName
          });
          if (typeof this._dialog.showModal !== 'function') return;
          event.preventDefault();
          this.open();
        }, listenerOptions);

        for (const option of this._stateOptions) {
          option.addEventListener('click', () => this.selectState(option), listenerOptions);
        }

        for (const closeControl of this.querySelectorAll('[data-request-info-close]')) {
          closeControl.addEventListener('click', () => {
            this.close(closeControl.dataset.requestInfoClose || 'close_button');
          }, listenerOptions);
        }

        this._dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close('escape');
        }, listenerOptions);

        this._dialog.addEventListener('pointerdown', (event) => {
          this._backdropPointerDown = event.target === this._dialog;
        }, listenerOptions);

        this._dialog.addEventListener('pointerup', (event) => {
          const shouldClose = event.target === this._dialog && this._backdropPointerDown;
          this._backdropPointerDown = false;
          if (shouldClose) this.close('backdrop');
        }, listenerOptions);

        this._dialog.addEventListener('pointercancel', () => {
          this._backdropPointerDown = false;
        }, listenerOptions);

        this._retry?.addEventListener('click', () => this.loadIframe(), listenerOptions);

        window.addEventListener('popstate', () => {
          const marker = history.state?.__boardcoRequestInfoModal;

          if (marker?.token === this._historyToken) {
            this._historyOwned = true;
            if (!this._dialog.open) this.open(true);
            return;
          }

          if (!this._dialog.open || !this._historyOwned) return;
          this._historyOwned = false;
          this.close('browser_back', true);
        }, listenerOptions);
      }

      disconnectedCallback() {
        if (this._dialog?.open) this.close('component_removed');
        this._controller?.abort();
        this.clearIframe();
        this.unlockBody();
        this._connected = false;
      }

      open(fromHistory = false) {
        if (this._dialog.open) return;

        this._productUrl = window.location.href;
        this._selectedState = '';
        this._formId = '';
        this._contextUrl = '';
        this._stateError.hidden = true;
        this.setView('state');

        this.lockBody();

        try {
          this._dialog.showModal();
        } catch (error) {
          this.unlockBody();
          window.location.assign(this._trigger.href);
          return;
        }

        if (fromHistory) {
          this._historyOwned = true;
        } else {
          this.pushHistory();
        }
        this.publish('boardco:request_info_form_opened', {
          button: this.dataset.requestInfoButtonName,
          state: '',
          form_id: '',
          modal_phase: 'state'
        });

        requestAnimationFrame(() => {
          this._stateOptions[0]?.focus({ preventScroll: true });
        });
      }

      selectState(option) {
        if (this._state !== 'state') return;

        const state = option.dataset.requestInfoState || '';
        const targetUrl = option.dataset.requestInfoUrl || '';
        const expectedForms = {
          Utah: '1RQUVYcbtQVYH4VPK24R',
          Texas: 'TbRCxNgKYpHIi54pilfQ',
          Idaho: '1RQUVYcbtQVYH4VPK24R',
          Other: '1RQUVYcbtQVYH4VPK24R'
        };

        if (!expectedForms[state] || !targetUrl) {
          this.showStateError();
          return;
        }

        try {
          const destination = new URL(targetUrl, window.location.href);
          const formId = destination.pathname.split('/').filter(Boolean).pop() || '';

          if (formId !== expectedForms[state]) {
            this.showStateError();
            return;
          }

          const parameters = new URLSearchParams();
          const cid = (document.cookie.match(/_shopify_y=([^;]+)/) || [])[1] || '';

          parameters.set('referer', this._productUrl);
          parameters.set('boardco_cid', cid);
          parameters.set('boardco_condition', this.dataset.requestInfoCondition);
          parameters.set('boardco_state', state);
          parameters.set('boardco_button', this.dataset.requestInfoButtonName);
          parameters.set('boardco_product_id', this.dataset.requestInfoProductId);
          parameters.set('boardco_product_title', this.dataset.requestInfoProductTitle);
          parameters.set('boardco_form_id', formId);
          destination.search = parameters.toString();

          this._selectedState = state;
          this._formId = formId;
          this._contextUrl = destination.toString();
          this._external.href = this._contextUrl;
          this._fallback.href = this._contextUrl;

          this.publish('boardco:state_selected', {
            button: this.dataset.requestInfoButtonName,
            state,
            form_url: targetUrl,
            form_id: formId
          });

          this.loadIframe();
        } catch (error) {
          this.showStateError();
        }
      }

      loadIframe() {
        if (!this._contextUrl) {
          this.showStateError();
          return;
        }

        this.clearIframe();
        this.setView('loading');
        this._attempt += 1;
        const attempt = this._attempt;
        const iframe = document.createElement('iframe');
        this._iframe = iframe;
        this._loadStartedAt = performance.now();

        iframe.className = 'request-info-modal__iframe';
        iframe.title = this.dataset.requestInfoIframeTitle;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.tabIndex = -1;
        iframe.setAttribute('aria-hidden', 'true');
        iframe.setAttribute('inert', '');

        iframe.addEventListener('load', () => {
          if (this._state !== 'loading' || this._attempt !== attempt || this._iframe !== iframe) return;
          window.clearTimeout(this._loadTimer);
          this._loadTimer = null;
          iframe.removeAttribute('aria-hidden');
          iframe.removeAttribute('inert');
          iframe.removeAttribute('tabindex');
          this.setView('form');
          this.announce(this.dataset.requestInfoLoadedStatus);
          this.publish('boardco:request_info_form_loaded', {
            button: this.dataset.requestInfoButtonName,
            state: this._selectedState,
            form_id: this._formId,
            modal_phase: 'form',
            attempt,
            load_duration_ms: Math.round(performance.now() - this._loadStartedAt)
          });
        }, { once: true });

        iframe.addEventListener('error', () => {
          this.showLoadError('iframe_error', attempt);
        }, { once: true });

        iframe.src = this._contextUrl;
        this._loadTimer = window.setTimeout(() => {
          this.showLoadError('timeout', attempt);
        }, 15000);
        this._frame.replaceChildren(iframe);
      }

      showLoadError(reason, attempt) {
        if (this._state !== 'loading' || this._attempt !== attempt) return;

        window.clearTimeout(this._loadTimer);
        this._loadTimer = null;
        this._iframe?.remove();
        this._iframe = null;
        this.setView('error');
        this.announce(this.dataset.requestInfoErrorStatus);
        this.publish('boardco:request_info_form_load_error', {
          button: this.dataset.requestInfoButtonName,
          state: this._selectedState,
          form_id: this._formId,
          modal_phase: 'error',
          error_reason: reason,
          timeout_ms: 15000,
          attempt
        });

        requestAnimationFrame(() => {
          this._fallback?.focus({ preventScroll: true });
        });
      }

      showStateError() {
        this._stateError.hidden = false;
        this._stateError.focus?.({ preventScroll: true });
      }

      setView(view) {
        this._state = view;
        this._dialog.dataset.requestInfoCurrentView = view;

        for (const panel of this._views) {
          panel.hidden = panel.dataset.requestInfoView !== view;
        }

        const titleByView = {
          state: this.dataset.requestInfoTitleState,
          loading: this.dataset.requestInfoTitleLoading,
          form: this.dataset.requestInfoTitleForm,
          error: this.dataset.requestInfoTitleError
        };
        this._title.textContent = titleByView[view] || this.dataset.requestInfoTitleForm;
        this._external.hidden = view !== 'form';

        if (view === 'loading') {
          this.announce(this.dataset.requestInfoLoadingStatus);
          requestAnimationFrame(() => {
            this._title.focus({ preventScroll: true });
          });
        }
      }

      close(reason, historyAlreadyConsumed = false) {
        if (!this._dialog.open) return;

        const phase = this._state;
        const state = this._selectedState;
        const formId = this._formId;
        const currentMarker = history.state?.__boardcoRequestInfoModal;
        const shouldUnwindHistory = !historyAlreadyConsumed
          && this._historyOwned
          && currentMarker?.token === this._historyToken;

        this._historyOwned = false;
        this.clearIframe();
        this._dialog.close();
        const scrollPosition = this.unlockBody();
        this.publish('boardco:request_info_form_closed', {
          button: this.dataset.requestInfoButtonName,
          state,
          form_id: formId,
          modal_phase: phase,
          close_reason: reason
        });

        this.setView('state');
        this._selectedState = '';
        this._formId = '';
        this._contextUrl = '';

        if (shouldUnwindHistory) {
          this.unwindHistory(scrollPosition);
        } else {
          this.restoreScrollPosition(scrollPosition);
        }

        requestAnimationFrame(() => {
          this._trigger.focus({ preventScroll: true });
        });
      }

      clearIframe() {
        window.clearTimeout(this._loadTimer);
        this._loadTimer = null;
        this._iframe?.remove();
        this._iframe = null;
        this._frame?.replaceChildren();
      }

      pushHistory() {
        this._historyToken = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        const currentState = history.state && typeof history.state === 'object' ? history.state : {};
        const nextState = Object.assign({}, currentState, {
          __boardcoRequestInfoModal: { token: this._historyToken }
        });

        try {
          history.pushState(nextState, '', this._productUrl);
          this._historyOwned = true;
        } catch (error) {
          this._historyOwned = false;
        }
      }

      unwindHistory(scrollPosition) {
        const previousScrollRestoration = history.scrollRestoration;
        let restored = false;
        let restoreTimer = null;

        const restore = () => {
          if (restored) return;
          restored = true;
          window.removeEventListener('popstate', restore);
          window.clearTimeout(restoreTimer);

          requestAnimationFrame(() => {
            if (scrollPosition) {
              window.scrollTo(scrollPosition.scrollX, scrollPosition.scrollY);
            }

            requestAnimationFrame(() => {
              if (scrollPosition) {
                window.scrollTo(scrollPosition.scrollX, scrollPosition.scrollY);
              }

              requestAnimationFrame(() => {
                this.restoreScrollAnchor(scrollPosition);

                try {
                  history.scrollRestoration = previousScrollRestoration;
                } catch (error) {
                }
              });
            });
          });
        };

        try {
          history.scrollRestoration = 'manual';
        } catch (error) {
        }

        window.addEventListener('popstate', restore, { once: true });
        restoreTimer = window.setTimeout(restore, 1000);

        try {
          history.back();
        } catch (error) {
          restore();
        }
      }

      restoreScrollPosition(scrollPosition) {
        if (!scrollPosition) return;

        requestAnimationFrame(() => {
          window.scrollTo(scrollPosition.scrollX, scrollPosition.scrollY);

          requestAnimationFrame(() => {
            window.scrollTo(scrollPosition.scrollX, scrollPosition.scrollY);

            requestAnimationFrame(() => {
              this.restoreScrollAnchor(scrollPosition);
            });
          });
        });
      }

      restoreScrollAnchor(scrollPosition) {
        if (!scrollPosition || !Number.isFinite(scrollPosition.anchorTop) || !this._trigger?.isConnected) return;

        const currentTop = this._trigger.getBoundingClientRect().top;
        const delta = currentTop - scrollPosition.anchorTop;

        if (Math.abs(delta) > 0.5) {
          window.scrollBy(0, delta);
        }
      }

      lockBody() {
        if (this._scrollLock) return;

        const body = document.body;
        const properties = [
          'position',
          'top',
          'inset-inline-start',
          'inline-size',
          'overflow',
          'padding-inline-end'
        ];
        const savedStyles = {};

        for (const property of properties) {
          savedStyles[property] = {
            value: body.style.getPropertyValue(property),
            priority: body.style.getPropertyPriority(property)
          };
        }

        const scrollX = window.scrollX;
        const scrollY = window.scrollY;
        const anchorTop = this._trigger?.getBoundingClientRect().top;
        const scrollbarGap = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
        const currentPadding = window.getComputedStyle(body).paddingInlineEnd;

        this._scrollLock = { scrollX, scrollY, anchorTop, savedStyles };
        body.classList.add('boardco-request-info-modal-open');
        body.style.setProperty('position', 'fixed');
        body.style.setProperty('top', `${-scrollY}px`);
        body.style.setProperty('inset-inline-start', `${-scrollX}px`);
        body.style.setProperty('inline-size', '100%');
        body.style.setProperty('overflow', 'hidden');
        body.style.setProperty('padding-inline-end', `calc(${currentPadding} + ${scrollbarGap}px)`);
      }

      unlockBody() {
        if (!this._scrollLock) return null;

        const body = document.body;
        const { scrollX, scrollY, anchorTop, savedStyles } = this._scrollLock;

        for (const property of Object.keys(savedStyles)) {
          const saved = savedStyles[property];
          if (saved.value) {
            body.style.setProperty(property, saved.value, saved.priority);
          } else {
            body.style.removeProperty(property);
          }
        }

        body.classList.remove('boardco-request-info-modal-open');
        this._scrollLock = null;
        window.scrollTo(scrollX, scrollY);
        return { scrollX, scrollY, anchorTop };
      }

      announce(message) {
        if (!this._live || !message) return;
        this._live.textContent = '';
        requestAnimationFrame(() => {
          this._live.textContent = message;
        });
      }

      publish(name, extra = {}) {
        try {
          const numericProductId = Number(this.dataset.requestInfoProductId);
          const data = {
            condition: this.dataset.requestInfoCondition,
            product_id: Number.isNaN(numericProductId) ? this.dataset.requestInfoProductId : numericProductId,
            product_title: this.dataset.requestInfoProductTitle,
            product_url: this._productUrl || window.location.href
          };

          Object.assign(data, extra);

          if (window.Shopify?.analytics?.publish) {
            window.Shopify.analytics.publish(name, data);
          }
        } catch (error) {
        }
      }
    }

    customElements.define('boardco-request-info-modal', BoardcoRequestInfoModal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["value-your-trade-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('boardco-trade-modal')) {
    class BoardcoTradeModal extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;
        this._connected = true;
        this._controller = new AbortController();
        this._dialog = this.querySelector('#state-select-modal-trade');
        this._trigger = this.querySelector('#value-your-trade-button');
        this._title = this.querySelector('#trade-modal-title');
        this._frame = this.querySelector('[data-trade-frame]');
        this._live = this.querySelector('[data-trade-live]');
        this._loadingStatus = this.querySelector('[data-trade-loading]');
        this._stateError = this.querySelector('[data-trade-state-error]');
        this._external = this.querySelector('[data-trade-external]');
        this._fallback = this.querySelector('[data-trade-fallback]');
        this._retry = this.querySelector('[data-trade-retry]');
        this._views = this.querySelectorAll('[data-trade-view]');
        this._stateOptions = this.querySelectorAll('.state-modal__option');
        this._attempt = 0;
        this._state = 'closed';
        this._historyOwned = false;
        this._historyToken = '';
        this._selectedState = '';
        this._formId = '';
        this._contextUrl = '';
        this._productUrl = '';
        this._iframe = null;
        this._loadTimer = null;
        this._loadStartedAt = 0;
        this._backdropPointerDown = false;
        this._scrollLock = null;

        if (!this._dialog || !this._trigger || !this._frame || !this._title) return;

        const listenerOptions = { signal: this._controller.signal };

        this._trigger.addEventListener('click', (event) => {
          if (typeof this._dialog.showModal !== 'function') return;
          event.preventDefault();
          this.open();
        }, listenerOptions);

        for (const option of this._stateOptions) {
          option.addEventListener('click', () => this.selectState(option), listenerOptions);
        }

        for (const closeControl of this.querySelectorAll('[data-trade-close]')) {
          closeControl.addEventListener('click', () => {
            this.close(closeControl.dataset.tradeClose || 'close_button');
          }, listenerOptions);
        }

        this._dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close('escape');
        }, listenerOptions);

        this._dialog.addEventListener('pointerdown', (event) => {
          this._backdropPointerDown = event.target === this._dialog;
        }, listenerOptions);

        this._dialog.addEventListener('pointerup', (event) => {
          const shouldClose = event.target === this._dialog && this._backdropPointerDown;
          this._backdropPointerDown = false;
          if (shouldClose) this.close('backdrop');
        }, listenerOptions);

        this._dialog.addEventListener('pointercancel', () => {
          this._backdropPointerDown = false;
        }, listenerOptions);

        this._retry?.addEventListener('click', () => this.loadIframe(), listenerOptions);

        window.addEventListener('popstate', () => {
          const marker = history.state?.__boardcoTradeModal;

          if (marker?.token === this._historyToken) {
            this._historyOwned = true;
            if (!this._dialog.open) this.open(true);
            return;
          }

          if (!this._dialog.open || !this._historyOwned) return;
          this._historyOwned = false;
          this.close('browser_back', true);
        }, listenerOptions);
      }

      disconnectedCallback() {
        if (this._dialog?.open) this.close('component_removed');
        this._controller?.abort();
        this.clearIframe();
        this.unlockBody();
        this._connected = false;
      }

      open(fromHistory = false) {
        if (this._dialog.open) return;

        this._productUrl = window.location.href;
        this._selectedState = '';
        this._formId = '';
        this._contextUrl = '';
        this._stateError.hidden = true;
        this.setView('state');
        this.publish('boardco:button_click', {
          button: this.dataset.buttonName
        });

        this.lockBody();

        try {
          this._dialog.showModal();
        } catch (error) {
          this.unlockBody();
          window.location.assign(this._trigger.href);
          return;
        }

        if (fromHistory) {
          this._historyOwned = true;
        } else {
          this.pushHistory();
        }
        this.publish('boardco:trade_form_opened', {
          button: this.dataset.buttonName,
          modal_phase: 'state'
        });

        requestAnimationFrame(() => {
          this._stateOptions[0]?.focus({ preventScroll: true });
        });
      }

      selectState(option) {
        if (this._state !== 'state') return;

        const state = option.dataset.state || '';
        const targetUrl = option.dataset.url || '';
        const expectedForms = {
          Utah: 'ShQtKC0p68CKTdh7hMyK',
          Texas: 'QVgFxlW5BCiyx0AOWrNU',
          Idaho: 'ShQtKC0p68CKTdh7hMyK',
          Other: 'ShQtKC0p68CKTdh7hMyK'
        };

        if (!expectedForms[state] || !targetUrl) {
          this.showStateError();
          return;
        }

        try {
          const destination = new URL(targetUrl, window.location.href);
          const formId = destination.pathname.split('/').filter(Boolean).pop() || '';

          if (formId !== expectedForms[state]) {
            this.showStateError();
            return;
          }

          const parameters = new URLSearchParams(destination.search);
          const cid = (document.cookie.match(/_shopify_y=([^;]+)/) || [])[1] || '';

          parameters.set('referer', this._productUrl);
          parameters.set('boardco_cid', cid);
          parameters.set('boardco_condition', this.dataset.condition);
          parameters.set('boardco_state', state);
          parameters.set('boardco_button', this.dataset.buttonName);
          parameters.set('boardco_product_id', this.dataset.productId);
          parameters.set('boardco_product_title', this.dataset.productTitle);
          parameters.set('boardco_form_id', formId);
          destination.search = parameters.toString();

          this._selectedState = state;
          this._formId = formId;
          this._contextUrl = destination.toString();
          this._external.href = this._contextUrl;
          this._fallback.href = this._contextUrl;

          this.publish('boardco:state_selected', {
            button: this.dataset.buttonName,
            state,
            form_url: targetUrl,
            form_id: formId
          });

          this.loadIframe();
        } catch (error) {
          this.showStateError();
        }
      }

      loadIframe() {
        if (!this._contextUrl) {
          this.showStateError();
          return;
        }

        this.clearIframe();
        this.setView('loading');
        this._attempt += 1;
        const attempt = this._attempt;
        const iframe = document.createElement('iframe');
        this._iframe = iframe;
        this._loadStartedAt = performance.now();

        iframe.className = 'trade-modal__iframe';
        iframe.title = this.dataset.iframeTitle;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.tabIndex = -1;
        iframe.setAttribute('aria-hidden', 'true');
        iframe.setAttribute('inert', '');

        iframe.addEventListener('load', () => {
          if (this._state !== 'loading' || this._attempt !== attempt || this._iframe !== iframe) return;
          window.clearTimeout(this._loadTimer);
          this._loadTimer = null;
          iframe.removeAttribute('aria-hidden');
          iframe.removeAttribute('inert');
          iframe.removeAttribute('tabindex');
          this.setView('form');
          this.announce(this.dataset.loadedStatus);
          this.publish('boardco:trade_form_loaded', {
            button: this.dataset.buttonName,
            state: this._selectedState,
            form_id: this._formId,
            modal_phase: 'form',
            attempt,
            load_duration_ms: Math.round(performance.now() - this._loadStartedAt)
          });
        }, { once: true });

        iframe.addEventListener('error', () => {
          this.showLoadError('iframe_error', attempt);
        }, { once: true });

        iframe.src = this._contextUrl;
        this._loadTimer = window.setTimeout(() => {
          this.showLoadError('timeout', attempt);
        }, 15000);
        this._frame.replaceChildren(iframe);
      }

      showLoadError(reason, attempt) {
        if (this._state !== 'loading' || this._attempt !== attempt) return;

        window.clearTimeout(this._loadTimer);
        this._loadTimer = null;
        this._iframe?.remove();
        this._iframe = null;
        this.setView('error');
        this.announce(this.dataset.errorStatus);
        this.publish('boardco:trade_form_load_error', {
          button: this.dataset.buttonName,
          state: this._selectedState,
          form_id: this._formId,
          modal_phase: 'error',
          error_reason: reason,
          timeout_ms: 15000,
          attempt
        });

        requestAnimationFrame(() => {
          this._fallback?.focus({ preventScroll: true });
        });
      }

      showStateError() {
        this._stateError.hidden = false;
        this._stateError.focus?.({ preventScroll: true });
      }

      setView(view) {
        this._state = view;
        this._dialog.dataset.view = view;

        for (const panel of this._views) {
          panel.hidden = panel.dataset.tradeView !== view;
        }

        const titleByView = {
          state: this.dataset.titleState,
          loading: this.dataset.titleLoading,
          form: this.dataset.titleForm,
          error: this.dataset.titleError
        };
        this._title.textContent = titleByView[view] || this.dataset.titleForm;
        this._external.hidden = view !== 'form';

        if (view === 'loading') {
          this.announce(this.dataset.loadingStatus);
          requestAnimationFrame(() => {
            this._title.focus({ preventScroll: true });
          });
        }
      }

      close(reason, historyAlreadyConsumed = false) {
        if (!this._dialog.open) return;

        const phase = this._state;
        const state = this._selectedState;
        const formId = this._formId;
        const currentMarker = history.state?.__boardcoTradeModal;
        const shouldUnwindHistory = !historyAlreadyConsumed
          && this._historyOwned
          && currentMarker?.token === this._historyToken;

        this._historyOwned = false;
        this.clearIframe();
        this._dialog.close();
        const scrollPosition = this.unlockBody();
        this.publish('boardco:trade_form_closed', {
          button: this.dataset.buttonName,
          state,
          form_id: formId,
          modal_phase: phase,
          close_reason: reason
        });

        this.setView('state');
        this._selectedState = '';
        this._formId = '';
        this._contextUrl = '';

        if (shouldUnwindHistory) {
          this.unwindHistory(scrollPosition);
        } else {
          this.restoreScrollPosition(scrollPosition);
        }

        requestAnimationFrame(() => {
          this._trigger.focus({ preventScroll: true });
        });
      }

      clearIframe() {
        window.clearTimeout(this._loadTimer);
        this._loadTimer = null;
        this._iframe?.remove();
        this._iframe = null;
        this._frame?.replaceChildren();
      }

      pushHistory() {
        this._historyToken = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        const currentState = history.state && typeof history.state === 'object' ? history.state : {};
        const nextState = Object.assign({}, currentState, {
          __boardcoTradeModal: { token: this._historyToken }
        });

        try {
          history.pushState(nextState, '', this._productUrl);
          this._historyOwned = true;
        } catch (error) {
          this._historyOwned = false;
        }
      }

      unwindHistory(scrollPosition) {
        const previousScrollRestoration = history.scrollRestoration;
        let restored = false;
        let restoreTimer = null;

        const restore = () => {
          if (restored) return;
          restored = true;
          window.removeEventListener('popstate', restore);
          window.clearTimeout(restoreTimer);

          requestAnimationFrame(() => {
            if (scrollPosition) {
              window.scrollTo(scrollPosition.scrollX, scrollPosition.scrollY);
            }

            requestAnimationFrame(() => {
              if (scrollPosition) {
                window.scrollTo(scrollPosition.scrollX, scrollPosition.scrollY);
              }

              requestAnimationFrame(() => {
                this.restoreScrollAnchor(scrollPosition);

                try {
                  history.scrollRestoration = previousScrollRestoration;
                } catch (error) {
                }
              });
            });
          });
        };

        try {
          history.scrollRestoration = 'manual';
        } catch (error) {
        }

        window.addEventListener('popstate', restore, { once: true });
        restoreTimer = window.setTimeout(restore, 1000);

        try {
          history.back();
        } catch (error) {
          restore();
        }
      }

      restoreScrollPosition(scrollPosition) {
        if (!scrollPosition) return;

        requestAnimationFrame(() => {
          window.scrollTo(scrollPosition.scrollX, scrollPosition.scrollY);

          requestAnimationFrame(() => {
            window.scrollTo(scrollPosition.scrollX, scrollPosition.scrollY);

            requestAnimationFrame(() => {
              this.restoreScrollAnchor(scrollPosition);
            });
          });
        });
      }

      restoreScrollAnchor(scrollPosition) {
        if (!scrollPosition || !Number.isFinite(scrollPosition.anchorTop) || !this._trigger?.isConnected) return;

        const currentTop = this._trigger.getBoundingClientRect().top;
        const delta = currentTop - scrollPosition.anchorTop;

        if (Math.abs(delta) > 0.5) {
          window.scrollBy(0, delta);
        }
      }

      lockBody() {
        if (this._scrollLock) return;

        const body = document.body;
        const properties = [
          'position',
          'top',
          'inset-inline-start',
          'inline-size',
          'overflow',
          'padding-inline-end'
        ];
        const savedStyles = {};

        for (const property of properties) {
          savedStyles[property] = {
            value: body.style.getPropertyValue(property),
            priority: body.style.getPropertyPriority(property)
          };
        }

        const scrollX = window.scrollX;
        const scrollY = window.scrollY;
        const anchorTop = this._trigger?.getBoundingClientRect().top;
        const scrollbarGap = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
        const currentPadding = window.getComputedStyle(body).paddingInlineEnd;

        this._scrollLock = { scrollX, scrollY, anchorTop, savedStyles };
        body.classList.add('boardco-trade-modal-open');
        body.style.setProperty('position', 'fixed');
        body.style.setProperty('top', `${-scrollY}px`);
        body.style.setProperty('inset-inline-start', `${-scrollX}px`);
        body.style.setProperty('inline-size', '100%');
        body.style.setProperty('overflow', 'hidden');
        body.style.setProperty('padding-inline-end', `calc(${currentPadding} + ${scrollbarGap}px)`);
      }

      unlockBody() {
        if (!this._scrollLock) return null;

        const body = document.body;
        const { scrollX, scrollY, anchorTop, savedStyles } = this._scrollLock;

        for (const property of Object.keys(savedStyles)) {
          const saved = savedStyles[property];
          if (saved.value) {
            body.style.setProperty(property, saved.value, saved.priority);
          } else {
            body.style.removeProperty(property);
          }
        }

        body.classList.remove('boardco-trade-modal-open');
        this._scrollLock = null;
        window.scrollTo(scrollX, scrollY);
        return { scrollX, scrollY, anchorTop };
      }

      announce(message) {
        if (!this._live || !message) return;
        this._live.textContent = '';
        requestAnimationFrame(() => {
          this._live.textContent = message;
        });
      }

      publish(name, extra = {}) {
        try {
          const numericProductId = Number(this.dataset.productId);
          const data = {
            condition: this.dataset.condition,
            product_id: Number.isNaN(numericProductId) ? this.dataset.productId : numericProductId,
            product_title: this.dataset.productTitle,
            product_url: this._productUrl || window.location.href
          };

          Object.assign(data, extra);

          if (window.Shopify?.analytics?.publish) {
            window.Shopify.analytics.publish(name, data);
          }
        } catch (error) {
        }
      }
    }

    customElements.define('boardco-trade-modal', BoardcoTradeModal);
  }
  } catch(e) { console.error(e); }
})();

})();
